import { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import InputSearch from 'components/v2/input/InputSearch';
import DataGridTable from 'components/v2/table/DataGridTable';
import { useCreateAdsCampaignOrderStep1 } from 'hooks/services/useCreateAdsCampaignOrderStep1';
import { useLocalization } from 'localization';

const CreateAdsCampaignOrderStep1 = () => {
  const { t } = useLocalization();
  const [textSearch, setTextSearch] = useState('');
  const { ui, serverState } = useCreateAdsCampaignOrderStep1();

  return (
    <Stack direction="column" gap={2} sx={{ margin: '2rem 1rem 1rem 0' }}>
      <Typography variant="h3">{t('orders.pages.new.ads.chooseCase')}</Typography>
      <Typography variant="body1">{t('orders.pages.new.ads.searchCaseAds')}</Typography>

      <Stack direction="row" justifyContent="flex-end">
        <InputSearch
          onSearch={val => setTextSearch(val)}
          placeholder={t('orders.pages.new.ads.searchCaseAds')}
          sx={{ width: { xs: '100%', sm: '40%' } }}
        />
      </Stack>

      <Box sx={{ minHeight: 400, display: { xs: 'none', md: 'block' } }}>
        <DataGridTable
          rows={serverState.data ?? []}
          columns={ui.table.columns ?? []}
          isHideFooter
          loading={serverState.isLoading}
          sx={{ minHeight: 400 }}
          rowHeight={100}
        />
      </Box>
    </Stack>
  );
};

export default CreateAdsCampaignOrderStep1;
